import {html, LitElement, unsafeCSS} from "lit";
import {customElement, property} from "lit/decorators.js";
import {type ClassInfo, classMap} from "lit/directives/class-map.js";
import styles from "./IdsSpinnerElement.css?inline";
import {ROOT_TAG} from "../../globals";
import {unsafeStatic} from "lit/static-html.js";

const tagName = `${ROOT_TAG}-interstate-spinner`;
export const InterstateSpinner = unsafeStatic(tagName);

@customElement(tagName)
export class IdsSpinnerElement extends LitElement {
  static styles = unsafeCSS(styles);

  @property()
  size: number = 10;

  @property({type: Boolean})
  contained = false;

  private _getSize() {
    return `${this.size}px`;
  }

  render() {
    const classNames: ClassInfo = {
      "ids-spinner": true,
      "contained": !!this.contained
    };

    return html`
      <div
        class=${classMap(classNames)}
        style="--ids-comp-spinner-size: ${this._getSize()};">
        <svg class=${"spinner"} viewBox=${"0 0 50 50"}>
          <circle
            class="path"
            cx="25"
            cy="25"
            r="18"
            stroke="var(--ids-comp-spinner-ring-color)"
            fill="var(--ids-comp-spinner-center-color)"
            stroke-width="5px"></circle>
        </svg>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [tagName]: IdsSpinnerElement;
  }
}
